import { ReactComponent as StarIcon } from 'src/images/svgs/reprofiling/stars.svg';
import styled from 'styled-components';
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 52rem;
`;
export const StyledTopPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 2.9rem 3.6rem;
  background: linear-gradient(-99deg, rgba(21, 28, 43, 0.40) -1.18%, rgba(15, 64, 91, 0.40) 33.04%, rgba(0, 108, 126, 0.40) 47.45%, rgba(0, 156, 139, 0.40) 69.26%, rgba(0, 154, 138, 0.40) 84.8%, rgba(0, 200, 119, 0.40) 99.87%), #1C2538;
  height: 32.1rem;

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    height: 24rem;
    padding: 2rem;
  }
`;
export const StyledStarIcon = styled(StarIcon)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
export const StyledContentPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 3.2rem;
  padding: 4rem;
  background: ${({
  theme
}) => theme.colors.background.main};
  min-height: 28rem;
  border-radius: ${({
  theme
}) => theme.radius.small};

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    padding: 2.4rem;
    gap: 2.4rem;
    min-height: auto;
  }
`;
export const StyledMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;
export const StyledGreeting = styled.h2`
  font-size: 2.4rem;
  font-weight: 400;
  color: ${({
  theme
}) => theme.colors.text};
  margin: 0;
  line-height: 1.08;

  span {
    color: ${({
  theme
}) => theme.colors.success.secondary};
    font-weight: 600;
  }

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    font-size: 2rem;
  }
`;
export const StyledMainTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
export const StyledMainTextRow = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;

  svg {
    color: ${({
  theme
}) => theme.colors.primary};
  }
`;
export const StyledMainText = styled.span`
  font-size: 4rem;
  font-weight: 600;
  color: ${({
  theme
}) => theme.colors.text};
  line-height: 1.19;

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    font-size: 2.8rem;
  }
`;
export const StyledSubtext = styled.p`
  font-size: 2rem;
  color: ${({
  theme
}) => theme.colors.text};
  margin: 0;
  line-height: 2.6rem;
  font-weight: 400;

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    font-size: 1.6rem;
    line-height: 2.2rem;
  }
`;
export const StyledButton = styled.button`
  background: ${({
  theme
}) => theme.colors.primary.main};
  color: #151C2B;
  border: 1px solid ${({
  theme
}) => theme.colors.primary.main};
  border-radius: 0.4rem;
  padding: 1rem 1.6rem;
  font-size: 1.6rem;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: #8fd41c;
  }
`;
export const StyledRiveWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 448px;
  height: 100%;

  canvas {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.lg}) {
    width: 450px;
  }

  @media screen and (max-width: ${({
  theme
}) => theme.sizes.md}) {
    width: 320px;
  }
  
`;